import { Button } from "@/components/ui/button";
import { rememberedTheme } from "@/themes";

/**
 * The sign-in screen.
 *
 * There is one button, because there is one flow: the redirect goes to
 * Cognito's managed login, which offers a password, an email code and Google
 * (ADR 0008). Rebuilding that chooser here would mean a self-hosted customer's
 * federated IdP had to be listed in our bundle.
 */
export function SignIn({ error, onSignIn }: { error?: string; onSignIn: () => void }) {
  // There is no session yet, so the name is the one this browser last saw.
  const { productName, logo } = rememberedTheme();
  return (
    <div className="flex min-h-screen items-center justify-center bg-backdrop bg-fixed px-6">
      <div className="w-full max-w-sm rounded-xl border border-chrome/10 bg-[rgb(var(--c-chrome-surface))] p-8 text-center backdrop-blur">
        <h1 className="erika-serif mb-2 text-2xl text-chrome">
          {logo ? <img src={logo} alt={productName} className="mx-auto mb-3 h-20 w-auto" /> : productName}
        </h1>
        <p className="mb-6 text-sm text-chrome/70">
          Ask questions grounded in your document library. Every claim is cited.
        </p>

        {error && (
          <p className="mb-4 rounded-lg border border-red-400/40 bg-red-950/40 px-3 py-2 text-left text-xs text-red-200">
            {error}
          </p>
        )}

        <Button variant="primary" className="w-full" onClick={onSignIn}>
          Sign in
        </Button>
      </div>
    </div>
  );
}
